<template>
<v-card flat>
    <v-container grid-list-xl>
          <v-layout class="mt-0" row wrap>                       
            <v-flex class="mt-0" xs12>
              <v-select
                outline
                v-model="selectedResponses"
                label="Responses"                
                placeholder="Select your responses"
                :items="cresponses"
                multiple                
                item-text="name"
                return-object
              ></v-select>                                                     
            </v-flex>                        
            </v-layout>
            <v-layout>
            <v-flex xs12>
              <v-card flat class="mt-2 mr-4 blue lighten-5" style="border-radius: 8px;">
                <v-chip 
                        v-for="(response,responseindex) in selectedResponses" 
                        :key="responseindex"
                        small 
                        close 
                        outline 
                        color="primary"
                        @input="responseDelete(responseindex)">
                    {{response.name}}
                </v-chip>
              </v-card> 
              </v-flex>         
            </v-layout>                  
        </v-container>
        <v-card-actions class="ma-0">
            <v-spacer></v-spacer>                  
                <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
                <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
        </v-card-actions>  
        </v-card>
</template>

<script>
export default {
  data(){
    return{
      selectedResponses:null,
    }
  },
  methods:{
    saveCard(){
      let index = this.$store.state.currentruleindex
      let rules = this.$store.state.rules
      let responseSet = rules[index].responses
      for(let i in this.selectedResponses)
      {
      let response = {"name":this.selectedResponses[i].name,"id":this.selectedResponses[i].id}
      responseSet.push(response)
      }
      let rule = {"keywords":rules[index].keywords,"responses":responseSet}      
      this.$store.dispatch('aupdaterule',{rule,index})
      let status = false
      this.$store.dispatch('arulemenuStatusChange',status)
      this.selectedResponses = null
    },
    cancelCard(){
      let status = false
      this.$store.dispatch('arulemenuStatusChange',status)
      this.selectedResponses = null
    },
    responseDelete(responseindex){
      this.selectedResponses.splice(responseindex,1)
    }
  },
  computed:{
        cresponses(){
            return this.$store.state.responses
        }
  }
}
</script>
